// PeptideVault v6.5 — Scanner tab

// ══════════════════════════════════════════════════════
// RENDER: SCANNER TAB
// ══════════════════════════════════════════════════════
function renderScannerTab() {
  const mode = S.scanMode   // 'lookup' | 'in' | 'out'
  const modeColor = { lookup:'var(--blue)', in:'var(--green)', out:'var(--red)' }[mode] || 'var(--blue)'
  const modeLabel = { lookup:'Lookup', in:'Scan In', out:'Scan Out' }[mode] || mode

  return `
  <div style="animation:fadeIn .25s ease;max-width:680px;margin:0 auto">
    <div class="row" style="margin-bottom:20px">
      <h2 style="font-size:20px;font-weight:700">Barcode Scanner</h2>
      <div class="spacer"></div>
      <span class="badge" style="background:${modeColor}22;color:${modeColor};font-size:12px;padding:4px 12px">${modeLabel} Mode</span>
    </div>

    <!-- Mode selector -->
    <div class="card" style="margin-bottom:16px">
      <div class="card-body" style="display:flex;gap:8px;align-items:center;flex-wrap:wrap">
        <span style="font-size:12px;font-weight:700;color:var(--text3);text-transform:uppercase;letter-spacing:.5px">Mode:</span>
        <button class="btn btn-sm ${mode==='lookup'?'btn-primary':'btn-secondary'}" onclick="setScanMode('lookup')">🔍 Lookup</button>
        <button class="btn btn-sm ${mode==='in'?'btn-success':'btn-secondary'}" style="${mode==='in'?'background:var(--green);color:white':''}" onclick="setScanMode('in')">+ Scan In</button>
        <button class="btn btn-sm ${mode==='out'?'btn-danger':'btn-secondary'}" style="${mode==='out'?'background:var(--red);color:white':''}" onclick="setScanMode('out')">− Scan Out</button>
        ${mode !== 'lookup' ? `
        <span class="sep"></span>
        <span style="font-size:12px;color:var(--text3)">Qty per scan:</span>
        <input type="number" class="form-input" id="scan-qty-input" style="width:64px;padding:5px 8px;font-size:13px" min="1" value="${S.scanQty}" oninput="S.scanQty=Math.max(1,+this.value||1)">
        ` : ''}
        <div class="spacer"></div>
        <button class="btn btn-ghost btn-sm" onclick="clearScanLog()">Clear Log</button>
      </div>
    </div>

    <!-- Scan target area — click to focus -->
    <div id="scan-display" class="scan-display" style="margin-bottom:16px;cursor:text;position:relative" onclick="focusScanInput()">
      <!-- Hidden input that captures scanner keystrokes — never destroyed -->
      <input id="scan-hw-input" type="text" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"
        style="position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;cursor:text;font-size:1px;z-index:1"
        oninput="onScanInputChange(this)" onkeydown="onScanKeydown(event)">
      <div id="scan-inner">
        <div style="font-size:36px;margin-bottom:8px">📷</div>
        <div style="font-size:16px;font-weight:500;color:var(--text3)">Ready to scan</div>
        <div style="font-size:13px;color:var(--text4);margin-top:4px">Point scanner here or type barcode below</div>
      </div>
    </div>

    <!-- Manual text input row -->
    <div class="row" style="margin-bottom:16px">
      <input class="form-input" id="scan-manual" style="flex:1" placeholder="Type barcode manually and press Enter…"
        autocomplete="off" onkeydown="onManualScanKey(event)">
      <button class="btn btn-primary" onclick="processManualScan()">Scan</button>
    </div>

    <!-- Session log -->
    <div class="card">
      <div class="card-header">
        <div class="card-title">Session Log</div>
        <span style="font-size:12px;color:var(--text3)" id="scan-log-count">0 scans</span>
      </div>
      <div id="scan-log" style="max-height:280px;overflow-y:auto">
        <div style="padding:24px;text-align:center;color:var(--text4);font-size:13px">No scans yet this session</div>
      </div>
    </div>
  </div>`
}

// ── Scanner state (session log lives outside S so it survives tab switches) ──
let _scanLog = []
let _scanBuffer = ''
let _scanBufferTimer = null

function setScanMode(mode) {
  S.scanMode = mode
  S.scanResult = null
  render()
  requestAnimationFrame(focusScanInput)
}

function focusScanInput() {
  document.getElementById('scan-hw-input')?.focus()
}

function clearScanLog() {
  _scanLog = []
  const el = document.getElementById('scan-log')
  if (el) el.innerHTML = `<div style="padding:24px;text-align:center;color:var(--text4);font-size:13px">No scans yet this session</div>`
  const ct = document.getElementById('scan-log-count')
  if (ct) ct.textContent = '0 scans'
}

// USB scanners fire rapid keystrokes then Enter — buffer them
function onScanInputChange(input) {
  _scanBuffer += input.value
  input.value = ''
  clearTimeout(_scanBufferTimer)
  _scanBufferTimer = setTimeout(() => {
    if (_scanBuffer.trim()) processScan(_scanBuffer.trim())
    _scanBuffer = ''
  }, 80)
}

function onScanKeydown(e) {
  if (e.key === 'Enter') {
    e.preventDefault()
    clearTimeout(_scanBufferTimer)
    const code = (_scanBuffer + (e.target.value || '')).trim()
    e.target.value = ''
    _scanBuffer = ''
    if (code) processScan(code)
  }
}

function onManualScanKey(e) {
  if (e.key === 'Enter') {
    e.preventDefault()
    processManualScan()
  }
}

function processManualScan() {
  const input = document.getElementById('scan-manual')
  const code = input?.value?.trim()
  if (!code) return
  input.value = ''
  processScan(code)
}

export {
  renderScannerTab,
  _scanLog,
  _scanBuffer,
  _scanBufferTimer,
  setScanMode,
  focusScanInput,
  clearScanLog,
  onScanInputChange,
  onScanKeydown,
  onManualScanKey,
  processManualScan
}
